// extracted by mini-css-extract-plugin
module.exports = {"olPopup":"DownloadConfirmationPopUp_olPopup__tK0Wt","btn":"DownloadConfirmationPopUp_btn__3wQQd","popup-text":"DownloadConfirmationPopUp_popup-text__2pNoc"};